// state
export const PROFILE = 'PROFILE'
export const AUTH_STATE = 'AUTH_STATE'
export const MODAL_CONFIG = 'MODAL_CONFIG'
export const LOADER_STATE = 'LOADER_STATE'
export const MODAL_RESPONSE = 'MODAL_RESPONSE'
export const MODAL_CONFIG_DEFAULT = 'MODAL_CONFIG_DEFAULT'
export const STATE_OFFER_NAMES = 'STATE_OFFER_NAMES'
export const STATE_GOALS_AND_DISPLAY = 'STATE_GOALS_AND_DISPLAY'
export const STATE_SELECTED_OFFER_NAME = 'STATE_SELECTED_OFFER_NAME'
export const STATE_APPROVE_OFFER_SUCCESS = 'STATE_APPROVE_OFFER_SUCCESS'
export const STATE_REJECT_OFFER_RESULT = 'STATE_REJECT_OFFER_RESULT'
export const STATE_ZONE_SALE_PRICES = 'STATE_ZONE_SALE_PRICES'
export const STATE_PENDING_APPROVALS = 'STATE_PENDING_OFFER_APPROVALS'
export const STATE_SELECTED_PENDING_APPROVALS = 'STATE_SELECTED_PENDING_APPROVALS'
export const SELECTED_DEPARTMENT = 'SELECTED_DEPARTMENT'
export const SELECTED_SUB_DEPARTMENT = 'SELECTED_SUB_DEPARTMENT'
export const SELECTED_CLASS = 'SELECTED_CLASS'
export const SELECTED_SUB_CLASS = 'SELECTED_SUB_CLASS'
export const LANDING_DATA = 'LANDING_DATA'
export const SELECTED_AGG_CELL = 'SELECTED_AGG_CELL'
export const SELECTED_OFFER = 'SELECTED_OFFER'
export const APPROVE_WITH_CHANGES_OLD = 'APPROVE_WITH_CHANGES_OLD'
export const APPROVE_WITH_CHANGES = 'APPROVE_WITH_CHANGES'
export const AGG_INPUT_FILTER_DATA = 'AGG_INPUT_FILTER_DATA'
export const APPROVE_WITH_CHANGES_RESULT = 'APPROVE_WITH_CHANGES_RESULT'
export const OFFER_DETAILS = 'OFFER_DETAILS'
export const BAR_CHART = 'BAR_CHART'
export const FORGOT_PASSWORD_STATE = 'FORGOT_PASSWORD_STATE'
export const LIFT_SIMULATION = 'LIFT_SIMULATION'
export const WATERFALL_DATA = 'WATERFALL_DATA'
export const DOWNLOAD_ERROR = 'DOWNLOAD_ERROR'
export const ALL_EMAILS = 'ALL_EMAILS'
export const EMAIL_SELECTED_BY_SUPERUSER = 'EMAIL_SELECTED_BY_SUPERUSER'
export const CALCULATION_FIELDS = 'CALCULATION_FIELDS'
export const SIMULATION_CHANGES = 'SIMULATION_CHANGES'
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const NAV_BAR_COLLAPSE = 'NAV_BAR_COLLAPSE'
export const OFFERS = 'OFFERS'
export const OFFER_ITEMS = 'OFFER_ITEMS'
export const SELECTED_MERCHANT = 'SELECTED_MERCHANT'

// Getters
export const AUTH_GETTER = 'AUTH_GETTER'
export const GET_PROFILE = 'GET_PROFILE'
export const MODAL_CONFIG_GETTER = 'MODAL_CONFIG_GETTER'
export const GET_LOADER_STATE = 'GET_LOADER_STATE'
export const MODAL_RESPONSE_GETTER = 'MODAL_RESPONSE_GETTER'
export const GET_OFFER_NAMES = 'GET_OFFER_NAMES'
export const GET_GOALS_AND_DISPLAY = 'GET_GOALS_AND_DISPLAY'
export const GET_SELECTED_OFFER_NAME = 'GET_SELECTED_OFFER_NAME'
export const GET_OFFER_DETAILS_DATA = 'GET_OFFER_DETAILS_DATA'
export const GET_OFFER_DETAILS_ERRORS = 'GET_OFFER_DETAILS_ERRORS'
export const GET_APPROVE_OFFER_SUCCESS = 'GET_APPROVE_OFFER_SUCCESS'
export const GET_REJECT_OFFER_RESULT = 'GET_REJECT_OFFER_RESULT'
export const GET_ZONE_SALE_PRICES = 'GET_ZONE_SALE_PRICES'
export const GET_AGGREGATED_FIX_TABLE = 'GET_AGGREGATED_FIX_TABLE'
export const GET_PENDING_AGGREGATED_SCROLLABLE_TABLE = 'GET_PENDING_AGGREGATED_SCROLLABLE_TABLE'
export const GET_PAST_AGGREGATED_SCROLLABLE_TABLE = 'GET_PAST_AGGREGATED_SCROLLABLE_TABLE'
export const GET_SELECTED_PENDING_APPROVALS = 'GET_SELECTED_PENDING_APPROVALS'
export const GET_SELECTED_DEPARTMENT = 'GET_SELECTED_DEPARTMENT'
export const GET_SELECTED_SUB_DEPARTMENT = 'GET_SELECTED_SUB_DEPARTMENT'
export const GET_SELECTED_CLASS = 'GET_SELECTED_CLASS'
export const GET_SELECTED_SUB_CLASS = 'GET_SELECTED_SUB_CLASS'
export const GET_LANDING_DATA = 'GET_LANDING_DATA'
export const GET_SELECTED_AGG_DATA = 'GET_SELECTED_AGG_DATA'
export const GET_SELECTED_OFFER = 'GET_SELECTED_OFFER'
export const GET_APPROVE_WITH_CHANGES = 'GET_APPROVE_WITH_CHANGES'
export const GET_APPROVE_WITH_CHANGES_OLD = 'GET_APPROVE_WITH_CHANGES_OLD'
export const GET_AGG_INPUT_FILTER_DATA = 'GET_AGG_INPUT_FILTER_DATA'
export const GET_APPROVE_WITH_CHANGES_RESULT = 'GET_APPROVE_WITH_CHANGES_RESULT'
export const GET_AGG_INPUT_FILTER_ID = 'GET_AGG_INPUT_FILTER_ID'
export const GET_BAR_CHART = 'GET_BAR_CHART'
export const GET_BAR_CHART_LEGENDS = 'GET_BAR_CHART_LEGENDS'
export const GET_FORGOT_PASSWORD_STATUS = 'GET_FORGOT_PASSWORD_STATUS'
export const GET_LIFT_SIMULATION = 'GET_LIFT_SIMULATION'
export const GET_LINE_CHART_RADIO = 'GET_LINE_CHART_RADIO'
export const GET_WATERFALL_DATA = 'GET_WATERFALL_DATA'
export const GET_DOWNLOAD_ERROR = 'GET_DOWNLOAD_ERROR'
export const GETTER_ALL_EMAILS = 'GETTER_ALL_EMAILS'
export const GETTER_EMAIL_SELECTED_BY_SUPERUSER = 'GETTER_EMAIL_SELECTED_BY_SUPERUSER'
export const GET_CALCULATION_FIELDS = 'GET_CALCULATION_FIELDS'
export const GET_SIMULATION_CHANGES = 'GET_SIMULATION_CHANGES'
export const GETTER_UPLOAD_FILE_RESPONSE = 'GETTER_UPLOAD_FILE_RESPONSE'
export const GETTER_CONFIRMATION_MAIL_RESPONSE = 'GETTER_CONFIRMATION_MAIL_RESPONSE'
export const CONFIRMATION_MAIL_RESPONSE = 'CONFIRMATION_MAIL_RESPONSE'
export const GET_NAV_BAR_COLLAPSE = 'GET_NAV_BAR_COLLAPSE'
export const GET_OFFERS = 'GET_OFFERS'
export const GET_OFFER_ITEMS = 'GET_OFFER_ITEMS'
export const GET_SELECTED_MERCHANT = 'GET_SELECTED_MERCHANT'

// Mutations
export const AUTH_MUTATION = 'AUTH_MUTATION'
export const MUTATE_PROFILE = 'MUTATE_PROFILE'
export const MUTATE_PROFILE_ERROR = 'MUTATE_PROFILE_ERROR'
export const CLEAR_AUTH_ERRORS_MUTATION = 'CLEAR_AUTH_ERRORS_MUTATION'
export const MODAL_CONFIG_MUTATE = 'MODAL_CONFIG_MUTATE'
export const MUTATE_LOADER_STATE = 'MUTATE_LOADER_STATE'
export const MODAL_RESPONSE_MUTATE = 'MODAL_RESPONSE_MUTATE'
export const MUTATE_OFFER_NAMES = 'MUTATE_OFFER_NAMES'
export const MUTATE_GOALS_AND_DISPLAY = 'MUTATE_GOALS_AND_DISPLAY'
export const MUTATE_SELECTED_OFFER_NAME = 'MUTATE_SELECTED_OFFER_NAME'
export const ADD_OFFER_DETAILS_DATA = 'ADD_OFFER_DETAILS_DATA'
export const REPORT_ERRORS_IN_OFFER_DETAIL = 'REPORT_ERRORS_IN_OFFER_DETAIL'
export const MUTATE_APPROVE_OFFER_SUCCESS = 'MUTATE_APPROVE_OFFER_SUCCESS'
export const MUTATE_REJECT_OFFER_RESULT = 'MUTATE_REJECT_OFFER_RESULT'
export const MUTATE_ZONE_SALE_PRICES = 'MUTATE_ZONE_SALE_PRICES'
export const MUTATE_PENDING_APPROVALS = 'MUTATE_PENDING_APPROVALS'
export const MUTATE_SELECTED_PENDING_APPROVALS = 'MUTATE_SELECTED_PENDING_APPROVALS'
export const MUTATE_SELECTED_DEPARTMENT = 'MUTATE_SELECTED_DEPARTMENT'
export const MUTATE_SELECTED_SUB_DEPARTMENT = 'MUTATE_SELECTED_SUB_DEPARTMENT'
export const MUTATE_SELECTED_CLASS = 'MUTATE_SELECTED_CLASS'
export const MUTATE_SELECTED_SUB_CLASS = 'MUTATE_SELECTED_SUB_CLASS'
export const MUTATE_LANDING_DATA = 'MUTATE_LANDING_DATA'
export const MUTATE_SELECTED_AGG_DATA = 'MUTATE_SELECTED_AGG_DATA'
export const MUTATE_SELECTED_OFFER = 'MUTATE_SELECTED_OFFER'
export const MUTATE_APPROVE_WITH_CHANGES = 'MUTATE_APPROVE_WITH_CHANGES'
export const MUTATE_APPROVE_WITH_CHANGES_OLD = 'MUTATE_APPROVE_WITH_CHANGES_OLD'
export const MUTATE_AGG_INPUT_FILTER_DATA = 'MUTATE_AGG_INPUT_FILTER_DATA'
export const MUTATE_APPROVE_WITH_CHANGES_RESULT = 'MUTATE_APPROVE_WITH_CHANGES_RESULT'
export const MUTATE_BAR_CHART = 'MUTATE_BAR_CHART'
export const MUTATE_APPROVE_WITH_CHANGES_DATA = 'MUTATE_APPROVE_WITH_CHANGES_DATA'
export const MUTATE_AUTH_EXPIRY = 'MUTATE_AUTH_EXPIRY'
export const MUTATE_FORGOT_PASSWORD = 'MUTATE_FORGOT_PASSWORD'
export const MUTATE_LIFT_SIMULATION = 'MUTATE_LIFT_SIMULATION'
export const MUTATE_WATERFALL_DATA = 'MUTATE_WATERFALL_DATA'
export const MUTATE_DOWNLOAD_ERROR = 'MUTATE_DOWNLOAD_ERROR'
export const MUTATE_ALL_EMAILS = 'MUTATE_ALL_EMAILS'
export const MUTATE_EMAIL_SELECTED_BY_SUPERUSER = 'MUTATE_EMAIL_SELECTED_BY_SUPERUSER'
export const MUTATE_CALCULATION_FIELDS = 'MUTATE_CALCULATION_FIELDS'
export const MUTATE_SIMULATION_CHANGES = 'MUTATE_SIMULATION_CHANGES'
export const UPLOAD_FILE_RESPONSE = 'UPLOAD_FILE_RESPONSE'
export const MUTATE_CONFIRMATION_MAIL_RESPONSE = 'MUTATE_CONFIRMATION_MAIL_RESPONSE'
export const MUTATE_NAV_BAR_COLLAPSE = 'MUTATE_NAV_BAR_COLLAPSE'
export const MUTATE_OFFERS = 'MUTATE_OFFERS'
export const MUTATE_OFFER_ITEMS = 'MUTATE_OFFER_ITEMS'
export const MUTATE_SELECTED_MERCHANT = 'MUTATE_SELECTED_MERCHANT'

// Actions
export const UPDATE_AUTH_USER_FROM_PROFILE = 'UPDATE_AUTH_USER_FROM_PROFILE'
export const ASYNC_AUTH_ACTION = 'ASYNC_AUTH_ACTION'
export const ACTION_PROFILE = 'ACTION_PROFILE'
export const CLEAR_AUTH_ERRORS_ACTION = 'CLEAR_AUTH_ERRORS_ACTION'
export const ACTION_DROPDOWN_VALUE = 'ACTION_DROPDOWN_VALUE'
export const GET_USER_FROM_LOCAL_STORAGE = 'GET_USER_FROM_LOCAL_STORAGE'
export const SET_MODAL_CONFIG_ACTION = 'SET_MODAL_CONFIG_ACTION'
export const LOADER_SHOW_ACTION = 'LOADER_SHOW_ACTION'
export const SET_MODAL_RESPONSE_ACTION = 'SET_MODAL_RESPONSE_ACTION'
export const ACTION_GOALS_AND_DISPLAY = 'ACTION_GOALS_AND_DISPLAY'
export const ACTION_FETCH_OFFER_NAMES = 'ACTION_FETCH_OFFER_NAMES'
export const ACTION_APPROVE_OFFER = 'ACTION_APPROVE_OFFER'
export const ACTION_SELECT_OFFER_NAME = 'ACTION_SELECT_OFFER_NAME'
export const REQUEST_OFFER_DETAILS_DATA = 'REQUEST_OFFER_DETAILS_DATA'
export const ACTION_FETCH_ZONE_SALE_PRICES = 'ACTION_FETCH_ZONE_SALE_PRICES'
export const ACTION_PENDING_APPROVALS = 'ACTION_PENDING_APPROVALS'
export const ACTION_SELECTED_PENDING_APPROVALS = 'ACTION_SELECTED_PENDING_APPROVALS'
export const SET_SELECTED_DEPARTMENT = 'SET_SELECTED_DEPARTMENT'
export const SET_SELECTED_SUB_DEPARTMENT = 'SET_SELECTED_SUB_DEPARTMENT'
export const SET_SELECTED_CLASS = 'SET_SELECTED_CLASS'
export const SET_SELECTED_SUB_CLASS = 'SET_SELECTED_SUB_CLASS'
export const FETCH_LANDING_DATA = 'FETCH_LANDING_DATA'
export const FETCH_SUB_DEPARTMENTS = 'FETCH_SUB_DEPARTMENTS'
export const FETCH_CLASSES = 'FETCH_CLASSES'
export const FETCH_SUB_CLASSES = 'FETCH_SUB_CLASSES'
export const ACTION_SELECTED_AGG_DATA = 'ACTION_SELECTED_AGG_DATA'
export const FETCH_APPROVE_WITH_CHANGES = 'FETCH_APPROVE_WITH_CHANGES'
export const SUBMIT_OFFER_LOCK = 'SUBMIT_OFFER_LOCK'
export const SET_AGG_INPUT_FILTER_DATA = 'SET_AGG_INPUT_FILTER_DATA'
export const ACTION_UPDATE_PET_DEPOT_FUNDING = 'ACTION_UPDATE_PET_DEPOT_FUNDING'
export const SET_ZONE_STATE = 'SET_ZONE_STATE'
export const UPDATE_ZONE_STATE = 'UPDATE_ZONE_STATE'
export const ACTION_REJECT_OFFER = 'ACTION_REJECT_OFFER'
export const RESET_FUNCTIONABLE_TO_DEFAULT = 'RESET_FUNCTIONABLE_TO_DEFAULT'
export const FETCH_BAR_CHART = 'FETCH_BAR_CHART'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const FETCH_LIFT_SIMULATION = 'FETCH_LIFT_SIMULATION'
export const FETCH_WATERFALL_DATA = 'FETCH_WATERFALL_DATA'
export const ACTION_DOWNLOAD_ALL_DETAILS = 'ACTION_DOWNLOAD_ALL_DETAILS'
export const ACTION_DOWNLOAD_MANUFACTURER_INFO = 'ACTION_DOWNLOAD_MANUFACTURER_INFO'
export const ACTION_DOWNLOAD_PORTAL_GUIDE = 'ACTION_DOWNLOAD_PORTAL_GUIDE'
export const ACTION_REMOVE_ITEM_BY_ID = 'ACTION_REMOVE_ITEM_BY_ID'
export const HARD_RESET_APPROVE_WITH_CHANGES = 'HARD_RESET_APPROVE_WITH_CHANGES'
export const ACTION_ALL_EMAILS = 'ACTION_ALL_EMAILS'
export const SET_EMAIL_SELECTED_BY_SUPERUSER = 'SET_EMAIL_SELECTED_BY_SUPERUSER'
export const POST_SIMULATION_CHANGES = 'POST_SIMULATION_CHANGES'
export const FETCH_CALCULATION_FIELDS = 'FETCH_CALCULATION_FIELDS'
export const RESET_OFFER_DETAILS = 'RESET_OFFER_DETAILS'
export const ACTION_UPLOAD_FILE = 'ACTION_UPLOAD_FILE'
export const ACTION_RESET_UPLOAD_FILE = 'ACTION_RESET_UPLOAD_FILE'
export const ACTION_DOWNLOAD_MERCHANT_TEMPLATE = 'ACTION_DOWNLOAD_MERCHANT_TEMPLATE'
export const ACTION_DOWNLOAD_DAX = 'ACTION_DOWNLOAD_DAX'
export const ACTION_SEND_CONFIRMATION_MAIL = 'ACTION_SEND_CONFIRMATION_MAIL'
export const ACTION_MISTAKES_IN_UPLOAD_FILE = 'ACTION_MISTAKES_IN_UPLOAD_FILE'
export const ACTION_NAV_BAR_COLLAPSE = 'ACTION_NAV_BAR_COLLAPSE'
export const RESET_SELECTED_PENDING_APPROVALS = 'RESET_SELECTED_PENDING_APPROVALS'
export const RESET_PENDING_APPROVALS = 'RESET_PENDING_APPROVALS'
export const SET_SELECTED_MERCHANT = 'SET_SELECTED_MERCHANT'
export const ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS = 'ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS'



// WEBPACK FOOTER //
// ./src/store/NameSpace.js